/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';

import s from './ModeSelection.module.scss';
import staticPageStyles from '../StaticPages/StaticPage.module.scss';

interface ModeSelectionProps {
  onYoungClicked: () => void;
  onOldClicked: () => void;
}

class ModeSelection extends React.Component<ModeSelectionProps> {
  render() {
    const { onYoungClicked, onOldClicked } = this.props;

    return (
      <div className={staticPageStyles.staticPage} data-nosnippet>
        <div className={staticPageStyles.card}>
          <div className={staticPageStyles.cardContent}>
            <div className={s.modeSelectionContainer}>
              <div className={s.youngModeContainer}>
                <h1>Bist du unter 18?</h1>
                <button
                  className="wideButton"
                  type="button"
                  onClick={onYoungClicked}
                >
                  Los geht&apos;s
                </button>
              </div>
              <div className={s.oldModeContainer}>
                <h1>Bist du über 18?</h1>
                <button
                  className="wideButton"
                  type="button"
                  onClick={onOldClicked}
                >
                  Los geht&apos;s
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ModeSelection;
